import sliceCreator from '../../index.jsx';
import {GET_POST_ACTIVITY_BY_ID } from '../../../constants/index.jsx';
const _getPostActivityByIdAction = sliceCreator('GET_POST_ACTIVITY_BY_ID', GET_POST_ACTIVITY_BY_ID, 'get');

const { asyncAction: getPostActivityByIdAction, reducer, clearData: clearGetPostActivityByIdAction } = _getPostActivityByIdAction;

export default reducer;

export {
    getPostActivityByIdAction,
    clearGetPostActivityByIdAction
}